import { render, staticRenderFns } from "./EditLogradourotipoPage.vue?vue&type=template&id=14350544"
import script from "./EditLogradourotipoPage.vue?vue&type=script&lang=js"
export * from "./EditLogradourotipoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports